import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./motion";

export const AsiDeFacil = () => {
  const { t } = useLang();
  return (
    <section id="how" className="relative bg-sage-deep text-white py-24 md:py-32 overflow-hidden scroll-mt-24" data-testid="how">
      <div className="absolute -top-32 right-0 w-[500px] h-[500px] rounded-full bg-natural/20 blur-[130px]" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <Reveal><span className="text-xs font-semibold uppercase tracking-[0.2em] text-sage-light">{t.how.eyebrow}</span></Reveal>
              <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-5xl font-light tracking-tight leading-[1.1]">{t.how.title}</h2></Reveal>
            </div>
          </div>
          <div className="lg:col-span-8 space-y-4">
            {t.how.steps.map((s, i) => (
              <motion.div key={s.n} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 }} className="group flex items-start gap-6 md:gap-10 rounded-3xl border border-white/10 hover:border-white/25 bg-white/[0.03] hover:bg-white/[0.06] p-8 md:p-10 transition-all duration-500" data-testid={`how-step-${i}`}>
                <span className="font-editorial text-5xl md:text-7xl text-sage-light/70 group-hover:text-sage-light transition-colors duration-500 leading-none">{s.n}</span>
                <div className="pt-1 md:pt-3">
                  <h3 className="font-heading text-2xl md:text-3xl font-medium">{s.t}</h3>
                  <p className="mt-2 text-white/60 text-lg leading-relaxed max-w-lg">{s.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
